export default __webpack_public_path__ + "static/media/AT001.de2c1f7c.mp3";